export default "/images/logo.png?63fc478c5e20d6e9e19595587973485a";